import { RequestModel } from "model";
import { RequestType } from "pages/RequestIndex/RequestIndex";

import RequestItemView from "~components/RequestItem/RequestItemView";

import styles from "./RequestIndexView.module.css";

type RequestIndexViewProps = {
  requests: Array<RequestModel>;
  requestType: RequestType;
};

export function RequestIndexView(props: RequestIndexViewProps) {
  const { requests, requestType } = props;

  return (
    <div className={styles.requestIndexViewContainer}>
      {requests.map((item: RequestModel, idx: number) => (
        <RequestItemView request={item} key={idx} requestType={requestType} />
      ))}
    </div>
  );
}
